import React from "react";
import DataSlider, {
  BoxTitle,
  ContentContainer,
  Details,
} from "components/common/DataSlider";
import { NutritionPieChart } from "pages/onboarding/macro-nutrients/MacroNutrients";

const KalorienSlider = ({ slidesData }) => {
  // Define bullet colors for nutrition types
  const bulletColors = {
    protein: "#c74343",
    carbs: "#2ecf96",
    fats: "#ffc403",
  };

  // Function to render the content of each slide
  const renderSlideContent = (slide, index, styleProps) => (
    <>
      <BoxTitle {...styleProps.boxTitle}>
        {" "}
        {index == 0 ? "Trainingstag" : "Trainsfrei"}
      </BoxTitle>
      <ContentContainer {...styleProps.contentContainer}>
        <NutritionPieChart data={slide} />
      </ContentContainer>
      <Details {...styleProps.details}>
        <div className="details-center">
          <div
            className="bullet"
            style={{ backgroundColor: bulletColors.protein }}
          ></div>
          <h3>
            <span>{parseFloat(slide.proteinData.toString()).toFixed(0)}%</span>
            <span>Eiweiß</span>
          </h3>
        </div>
        <div className="details-center">
          <div
            className="bullet"
            style={{ backgroundColor: bulletColors.carbs }}
          ></div>
          <h3>
            <span>
              {parseFloat(slide.carbohydratesData.toString()).toFixed(0)}%
            </span>
            <span>Kohlenhydrate</span>
          </h3>
        </div>
        <div className="details-center">
          <div
            className="bullet"
            style={{ backgroundColor: bulletColors.fats }}
          ></div>
          <h3>
            <span>{parseFloat(slide.fatData.toString()).toFixed(0)}%</span>
            <span>Fett</span>
          </h3>
        </div>
      </Details>
    </>
  );

  return (
    <DataSlider
      slides={slidesData}
      renderSlideContent={renderSlideContent}
      navigationColor="#2ECF96"
    />
  );
};

export default KalorienSlider;
